import React, { forwardRef } from "react";
import { Input } from "antd";
import type { TextAreaProps, TextAreaRef } from "antd/es/input/TextArea";
import { useControlledInputValue } from "./UseControlledInputValue";

const StyledTextArea = forwardRef<TextAreaRef, TextAreaProps>(
  ({ className, value, defaultValue, onChange, ...props }, ref) => {
    const controlled = useControlledInputValue(
      value,
      defaultValue,
      onChange
    );

    return (
      <Input.TextArea
        {...props}
        ref={ref}
        value={controlled.value}
        onChange={controlled.onChange}
        className={`styled-text-input ${
          controlled.hasValue ? "styled-text-input--has-value" : ""
        } ${className || ""}`}
      />
    );
  }
);

StyledTextArea.displayName = "StyledTextArea";

export default StyledTextArea;
